import "./AboutMe.css";

export default function AboutMe() {

    return(
        <div className="AboutMe" id="about-me">
        <div className="bio">
            <div className="bio-title"> 
            <h2>i love problem solving with AI, managing complex technical projects...</h2>
                 
            <h2>
                and i absolutely adore cocker spaniels.</h2>
            </div>

            <div className="bio-body">
            <div className="bio-text">
            <span>  I am a Delivery Lead  </span>and Project Manager. 
            As a natural problem solver, I am able to use my AI implementation strategies, UX and coding knowledge to create great user experiences.</div>
            <div className="bio-text">
            <span>I love designing, building and leading projects, </span> I have a keen eye for fine detail & simple design.
            </div>
            
            </div>
        </div>
        </div>
    )
}
